var React = require('react');

function CarouselCirclePrev (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1,.cls-2{fill:none;stroke:#231f20;stroke-miterlimit:8;}.cls-1{stroke-linecap:square;}.cls-2{stroke-linecap:round;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M32.29,16.87l-12,12,12,12","key":0}),React.createElement("circle",{"className":"cls-2","cx":"28.87","cy":"28.87","r":"28.37","key":1})]))]);
}

CarouselCirclePrev.defaultProps = {"viewBox":"0 0 57.74 57.74"};

module.exports = CarouselCirclePrev;

CarouselCirclePrev.default = CarouselCirclePrev;
